module.exports = __webpack_public_path__ + "static/media/blocked.36cbdd77.png";